angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsServiceFailureCtrl", [
  "$scope", "$controller", "ApplicationService",
  ($scope, $controller, ApplicationService) ->
    $scope.outageImage = require('@amount/frontend-styles/src/images/dec/dec-404-small.png')
    $scope.page = "service_failure"

    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope}))

    $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })

    $scope.$on '$viewContentLoaded', ->
      # Close any open modals or loading spinners
      if $scope.useAmountLoadingSpinner then $scope.closeAmountLoadingSpinner()
      if $scope.useAmountModal then $scope.closeAmountModal()
]
